import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { tap } from 'rxjs/operators';

import { APP_ROUTE } from 'app/app-routing.constant';
import { collapseAnimation } from 'app/core/app-constants/angular-animations';
import { AuthenticationService } from 'app/core/authentication';
import { MinistrySurveyModel } from 'app/core/ministry-feedback/ministry.model';
import { MinistryFeedbackService } from 'app/core/ministry-feedback/ministry-feedback.service';
import { ModalService } from 'app/core/modals/services/modal.service';
import { LogicalErrorDocumentType } from 'app/shared/constants/logical-error-document-type';
import { LogicalErrorDocument } from 'app/shared/models/logical-error-document';
import { RemediationLogicalErrorModel } from 'app/shared/models/remediation-logical-error.model';
import { ClassInfo } from 'app/teacher/models/class-info';
import { TeacherService } from 'app/teacher/services/teacher.service';

@UntilDestroy()
@Component({
  animations: [collapseAnimation],
  selector: 'kh-remediation-modal',
  styleUrls: ['./remediation-modal.component.less'],
  templateUrl: './remediation-modal.component.html',
  standalone: false
})
export class RemediationModalComponent implements OnInit {
  private readonly teacherService = inject(TeacherService);
  private readonly feedbackService = inject(MinistryFeedbackService);
  private readonly modalService = inject(ModalService);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly authService = inject(AuthenticationService);

  public classInfo = this.teacherService.activeClassInfo as ClassInfo;
  public logicalError!: RemediationLogicalErrorModel;
  public showLearnMore = false;
  public survey!: MinistrySurveyModel;
  public show = false;
  public closed = false;
  public documentType = LogicalErrorDocumentType;
  public skipSurvey = false;
  public forcePremium = false;

  public ngOnInit(): void {
    this.closed = false;
    if (!this.skipSurvey) {
      this.feedbackService.getTeacherSurvey().pipe(
        tap((survey) => {
          this.survey = survey;
        }),
        untilDestroyed(this)
      )
        .subscribe();
    }
    this.show = this.logicalError?.IsRemediationDocumentAvailable || this.classInfo?.IsPremium || this.forcePremium;
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }

  public getRemediationDocumentRoute(document: LogicalErrorDocument): string[] {
    return APP_ROUTE.TEACHING_SUPPORTS.REMEDIATION.DOCUMENT.route(
      this.logicalError.LogicalErrorId, document.DocumentType);
  }
}
